import axiosInstance from "../../utility/axios";
import {
  setNotifications,
  setNotification,
  deleteNotification as deleteNotificationById,
  setLoading,
  setLoadingId,
} from "../../store/slices/notification";
import { AppDispatch } from "../../store/store";
import { isAxiosError } from "axios";
import {
  ICreateNotification,
  INotificationResponseData,
} from "../../store/types/notification";
import { toast } from "sonner";
import { IApiResponse } from "../../store/types/api-response";

const notificationEndpoint = "/api/v1/admin/notifications";

export const get_notifications = async (
  dispatch: AppDispatch,
  limit: number,
  offset: number,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<
      IApiResponse<INotificationResponseData>
    >(`${notificationEndpoint}`, {
      params: { limit, offset },
    });

    dispatch(setNotifications(response.data));
  } catch (err) {
    if (isAxiosError(err)) {
      const errorMessage =
        err.response?.data?.message || "Failed to fetch notifications";
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const get_notification = async (dispatch: AppDispatch, id: number) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`${notificationEndpoint}/${id}`);
    dispatch(setNotification(response.data));
  } catch (err) {
    if (isAxiosError(err)) {
      const errorMessage =
        err.response?.data?.message || "Failed to fetch notification";

      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const create_notification = async (
  formData: ICreateNotification,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading(true));

  try {
    const response = await axiosInstance.post(
      `${notificationEndpoint}`,
      formData,
    );
    const { message } = response?.data;
    toast.success(message);
    return { success: true };
  } catch (err) {
    if (isAxiosError(err)) {
      const errorMessage =
        err.response?.data?.message || "Failed to create notification";

      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const delete_notification = async (
  id: number,
  dispatch: AppDispatch,
) => {
  dispatch(setLoadingId(id));
  try {
    const response = await axiosInstance.delete(
      `${notificationEndpoint}/${id}`,
    );
    const { message } = response?.data;

    toast.success(message);
    dispatch(deleteNotificationById(id));
    return { success: true };
  } catch (err) {
    dispatch(setLoadingId(null));
    if (isAxiosError(err)) {
      const errorMessage =
        err.response?.data?.message || "Failed to delete notification";
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  }
};
